import { PopupInitializer } from '../Popup/Popup';
import { EventSearchResult } from '../types';
import { updateSearchResultHtml } from './eventSearchUtils';

export class EventSearchInitializer {
	/** Pagination - keep track of current page */
	currentPage = 1;

	loadMoreButton: HTMLButtonElement | null = document.querySelector('#load-more');

	event = new Event('eventLoad');

	/**
	 * Initializes the EventFilter.
	 *
	 * @returns void
	 */
	init() {
		const initEventForms = document.querySelectorAll<HTMLFormElement>('form.initEventsSearchForm');

		this.loadMoreButton?.addEventListener('click', (e) => {
			e.preventDefault();

			this.currentPage += 1;

			initEventForms.forEach((initEventForm) => {
				this.sendForm(initEventForm, true);
			});
		});

		initEventForms.forEach((initEventForm) => {
			this.sendForm(initEventForm);

			this.deleteListener(initEventForm);

			initEventForm.addEventListener('change', (event) => {
				event.preventDefault(); // Prevent default form submission
				this.sendForm(initEventForm);
			});
			initEventForm.addEventListener('submit', (event) => {
				event.preventDefault(); // Prevent default form submission
				this.sendForm(initEventForm);
			});
		});
	}

	deleteListener = (form: HTMLFormElement) => {
		const deleteButtons = form.querySelectorAll('.delete-selection.all');

		deleteButtons.forEach((deleteButton) =>
			deleteButton.addEventListener('click', () => setTimeout(() => this.sendForm(form), 0))
		);
	};

	sendForm(form: HTMLFormElement, loadMore?: boolean) {
		let actionUrl = form.action;

		if (loadMore === true) {
			actionUrl += `&page=${this.currentPage}`;
		} else {
			// New search request has been made - reset pagination
			this.currentPage = 1;
		}

		const formData = new FormData(form);

		const dateRange = form.querySelector<HTMLInputElement>('#dateRange');

		formData.append('tx_module_deloevents[customDateRange]', dateRange?.value!);
		const container = form.parentNode?.querySelector<Element>('.searchresult-container');
		container?.setAttribute('aria-busy', 'true');

		fetch(actionUrl, {
			method: form.method,
			body: formData,
		})
			.then((response): Promise<EventSearchResult> => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((data) => {
				if (container != null) {
					const noResults = data.html.length === 0;
					const noResultsContainer = form.parentNode?.querySelector<HTMLHeadingElement>('.no-results');

					noResults
						? noResultsContainer?.classList.remove('hidden')
						: noResultsContainer?.classList.add('hidden');

					// Append additional result pages without rebuilding the previous DOM string.
					updateSearchResultHtml(container, data.html, loadMore === true);
				}

				data.pagination === this.currentPage
					? this.loadMoreButton?.classList.add('hidden')
					: this.loadMoreButton?.classList.remove('hidden');

				container?.setAttribute('aria-busy', 'false');
				container?.dispatchEvent(this.event);

				PopupInitializer.init();

				form.querySelectorAll(
					':is(.category-container-wrapper, .eventtype-container-wrapper) .delete-selection.single'
				).forEach((del) => {
					del.addEventListener('click', () => {
						this.sendForm(form);
					});
				});
			})
			.catch((error) => {
				container?.setAttribute('aria-busy', 'false');
				console.error('Error:', error);
			});
	}
}
